import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import SEOHead from "@/components/base/SEOHead";
import HeroSection from "./components/HeroSection";
import FeaturedComics from "./components/FeaturedComics";
import LatestUpdates from "./components/LatestUpdates";
import PopularRanking from "./components/PopularRanking";
import FAQSection from "./components/FAQSection";
import { comics, rankingComics, latestComics, recommendedComics } from "@/mocks/comics";

const homeSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: "非麻瓜漫画",
  url: "https://feimagua.com",
  description: "非麻瓜漫画作为专业的免费韩漫在线阅读网，致力于第一时间更新最新韩国漫画资源。我们采用无缝下拉式观看模式，让您紧跟剧情发展，享受无断点、无广告的沉浸式阅读乐趣。",
  potentialAction: {
    "@type": "SearchAction",
    target: "https://feimagua.com/search?q={search_term_string}",
    "query-input": "required name=search_term_string",
  },
  inLanguage: "zh-CN",
};

const orgSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "非麻瓜漫画",
  url: "https://feimagua.com",
  description: "专业的免费韩漫在线阅读平台",
  sameAs: ["https://feimagua.com"],
};

export default function Home() {
  return (
    <>
      <SEOHead
        title="非麻瓜漫画-免费韩漫在线阅读网_最新韩国漫画下拉式观看"
        description="非麻瓜漫画作为专业的免费韩漫在线阅读网，致力于第一时间更新最新韩国漫画资源。我们采用无缝下拉式观看模式，让您紧跟剧情发展，享受无断点、无广告的沉浸式阅读乐趣。"
        keywords="非麻瓜漫画,免费韩漫,在线阅读网,最新韩国漫画,下拉式观看,即时更新"
        canonicalUrl="https://feimagua.com"
        schema={{ ...homeSchema, ...orgSchema }}
      />

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main>
          <HeroSection />

          <FeaturedComics comics={comics.filter((c) => c.isHot).slice(0, 10)} />

          <LatestUpdates comics={latestComics} />

          <PopularRanking comics={rankingComics} />

          <section className="max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
            <div className="text-center mb-6">
              <h2 className="text-xl md:text-2xl font-display text-foreground-950">
                高分推荐
              </h2>
              <p className="text-sm text-foreground-500 mt-1">
                评分最高的口碑佳作
              </p>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
              {recommendedComics.map((comic) => (
                <Link
                  key={comic.id}
                  to={`/article/${comic.id}`}
                  className="group cursor-pointer"
                  data-product-shop=""
                >
                  <div className="relative aspect-[3/4] rounded-lg overflow-hidden bg-background-200 mb-2">
                    <img
                      src={comic.coverImage}
                      alt={comic.title}
                      title={`${comic.title} - 免费韩漫在线阅读`}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                    />
                    <div className="absolute bottom-0 inset-x-0 bg-gradient-to-t from-black/60 to-transparent p-3">
                      <div className="flex items-center gap-1 text-xs text-background-50">
                        <i className="ri-star-fill text-accent-500"></i>
                        <span>{comic.rating}</span>
                        <span className="mx-1">·</span>
                        <span>{comic.category}</span>
                      </div>
                    </div>
                  </div>
                  <h3 className="text-xs font-medium text-foreground-900 line-clamp-1 group-hover:text-primary-500 transition-colors">
                    {comic.title}
                  </h3>
                </Link>
              ))}
            </div>
          </section>

          <FAQSection />
        </main>

        <Footer />
      </div>
    </>
  );
}